<template>
  <ul :class="`set_language ${isDark ? 'dark' : ''}`">
    <li
      :class="`${
        $store.state.language_current === key ? 'active-language' : ''
      }`"
      v-for="(lang, key) in $store.state.languages"
      :key="key"
      @click="setLanguage(key)"
    >
      <div>
        <span>{{ lang }}</span>
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    isDark: {
      default: false,
    },
  },
  methods: {
    setLanguage(lang) {
      this.$loading(true);
      this.$store.dispatch("setLanguageCurrent", lang);
      localStorage.setItem("lang", lang);
      window.location.reload(true);
    },
  },
};
</script>

